import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

const ContactList = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get('https://aaryanholidays.in/backend/contact');
        setTestimonials(response.data);
      } catch (error) {
        console.error('There was an error fetching the User!', error);
      }
    };
    fetchTestimonials();
  }, []);

  

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Contact List
      </Typography>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Message</TableCell>
             
             
            </TableRow>
          </TableHead>
          <TableBody>
            {testimonials.map((testimonial) => (
              <TableRow key={testimonial.id}>
                
                <TableCell>{testimonial.name}</TableCell>
                <TableCell>{testimonial.email}</TableCell>
                <TableCell>{testimonial.phone}</TableCell>
                <TableCell>{testimonial.message}</TableCell>
               
                
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ContactList;
